import styled from 'styled-components';
import { device } from '../../styles/devices';
import { COLORS } from '../../styles/variables';

export const Legal = styled.div`
  display: flex;
  flex-direction: column;
  margin: 48px 0 28px;
  gap: 24px;

  @media ${device.tablet} {
    margin: 36px 0;
  }

  @media ${device.laptop} {
    margin: 60px 0 40px;
  }
`;

export const CcpaContaner = styled.div``;

export const LegalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const RegularDiscalimer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const CheckboxContainer = styled.div`
  margin-top: 24px;
`;

export const LegalHeader = styled.h3`
  font-family: 'Audi Type Extended';
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.002px;
  font-style: normal;
  font-weight: 400;
  color: ${COLORS.grey80};
  padding-bottom: 12px;
  margin-bottom: 4px;
`;

export const TextContainer = styled.p`
  font-family: 'Audi Type';
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.002px;
  font-style: normal;
  font-weight: 400;
  color: ${COLORS.grey80};
`;

export const Url = styled.a`
  color: ${COLORS.grey80};
  text-decoration: none;
  font-family: 'Audi Type';
  font-size: 12px;
  font-weight: 700;
  line-height: 20px;
  border-bottom: 1px solid ${COLORS.grey80};
  padding-bottom: 2px;
`;
